import { combine, createEvent, forward, restore } from 'effector-root'
import { attach } from 'effector'
import { createFiltersModel } from '@/pages/common/filters/create-filters-model'
import { createPageParamsModel } from '@/pages/common/page-params/create-page-params-model'
import { dropdownModules } from '@/pages/users/groups/list/model/tooltip-filter.model'
import {
  $studentsForGroupsIds,
  resetFields,
} from '@/pages/users/groups/create/model/form-fileds.model'
import { getStudentsGroupsListFx } from '@/features/api/groups/get-students-list'
import { StudentAppointmentsDataMinimal } from '@/pages/users/groups/create/model/types'

export const studentGroupsFilters = createFiltersModel(
  {
    search_area: 'search_all',
    per_page: 1000,
  },
  dropdownModules
)

export const getStudentsGroupsList = attach({
  effect: getStudentsGroupsListFx,
  source: studentGroupsFilters.store.$filterParams,
  mapParams: (_, filters) => {
    return filters
  },
})

export const loadStudents = createEvent()

export const studentGroupsPageParams = createPageParamsModel()

export const resetStudentGroupFilters = createEvent<void>()

export const setGroupsStudentsList = createEvent<StudentAppointmentsDataMinimal[]>()
export const $groupsStudentsList = restore<StudentAppointmentsDataMinimal[]>(
  setGroupsStudentsList,
  []
).reset(resetFields)

export const setStudentIds = createEvent<string>()
export const $studentIds = restore<string>(setStudentIds, '').reset(resetFields)

export const $studentsForTableGroups = combine(
  $groupsStudentsList,
  $studentsForGroupsIds,
  (list, ids) => {
    return {
      list: list.map((item) => {
        return {
          ...item,
          isChecked: ids.includes(item.id),
        }
      }),
      total: list.length,
    }
  }
)

forward({
  from: getStudentsGroupsList.doneData.map(({ body }) =>
    body.data.map((student) => {
      return {
        ...student,
        study_year: student.study_year.name,
      }
    })
  ),
  to: setGroupsStudentsList,
})

forward({
  from: loadStudents,
  to: getStudentsGroupsList,
})
